// extracted by mini-css-extract-plugin
export default {"tickContainer":"TickComponent__tickContainer___E9TqP"};